// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/* tslint:disable */
/**
 * The main menu token.
 */
export const IMainMenu = new Token('@jupyterlab/mainmenu:IMainMenu');
//# sourceMappingURL=tokens.js.map